// extracted by mini-css-extract-plugin
export default {"analyticsContainer":"Student_analyticsContainer__hy-I5"};